export default __webpack_public_path__ + "static/media/graficos-04.77c66ce2.png";